import {gsap, smoother, ScrollTrigger} from "../Utility/gsap";
import {evaluateExpression} from "../Utility/utils";
class scrollSliderTicker {
  constructor(el) {
    this.el = el;
    this.innerEl = el.querySelector('.scrolling_slider__inner');
    this.images = el.querySelectorAll('.scrolling_slider__group.main .scrolling_slider__img');
    this.direction = el.classList.contains('left') ? -1 : 1;
    this.speed = el.getAttribute('data-speed');
    this.tweenToX = (this.direction * 100) + '%';

    // Set CSS Props to help with container width
    this.setCSSProps();
    
    // Play the static ticker animation
    this.tween = this.setTween();
    
    // Watch to accelerate the ticker animation timing
    this.scrollTrigger = this.setScrollTrigger();
    this.velocity = 0;
    this.timeScaleOffset = 0;
  }

  setTween(){
    const tween = gsap.to( this.innerEl, {
      x: this.tweenToX,
      duration: this.speed,
      ease: 'linear',
      repeat: -1
    });

    return tween;
  }

  setScrollTrigger(){
    const sliderScrollTrigger = ScrollTrigger.create({
      trigger: document.body,
      start: `top top`,
      end: `bottom bottom`,
      onUpdate: () => {
        this.timeScaleOffset = this.getScrollVelocity();
        this.tween.timeScale(1+this.timeScaleOffset);
      }
    });

    return sliderScrollTrigger;
  }

  getScrollVelocity() {
    // Ensure velocity is a positive number
    let velocity = smoother ? smoother.getVelocity() : 0;
    this.velocity = velocity < 0 ? velocity * -1 : velocity;

    // Set acceleration based on velocity, tempered.
    const acceleration = this.velocity * .007;

    return acceleration;
  }

  setCSSProps() {
    let desktopWidth = 0;
    let mobileWidth = 0;

    this.images.forEach(image => {
      const imgComputedStyle = getComputedStyle(image);
      const imgDesktopWidth = imgComputedStyle.getPropertyValue('--slide-width-desktop');
      let imgMobileWidth = imgComputedStyle.getPropertyValue('--slide-width-mobile');
      
      // Check if the imgMobileWidth is a css calc()
      if(imgMobileWidth.includes("calc")){
        const expression = imgMobileWidth.replace(/^calc\((.+)\)$/, '$1');
        imgMobileWidth = evaluateExpression(expression);
      }

      desktopWidth= desktopWidth + parseInt(imgDesktopWidth);
      mobileWidth= mobileWidth + parseInt(imgMobileWidth);
    });

    this.el.style.setProperty('--total-image-width-desktop', desktopWidth + 'px');
    this.el.style.setProperty('--total-image-width-mobile', mobileWidth + 'px');
  }
}

const InitScrollBasedImageSlider = () => {
  const sliders = document.querySelectorAll('.scrolling_slider');
  
  if(sliders){
      sliders.forEach(sliderEl => {
        slider = new scrollSliderTicker(sliderEl);
      });
  };
}

export {InitScrollBasedImageSlider};